"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.computeBbox = computeBbox;
var _vector = require("./vector");
var _getPointTangent = require("./getPointTangent");
var _convertLineToArc = require("./convertLineToArc");
/**
 * Computes the bounding box of an array of entities
 * @param {Array} entities An array of entities
 * @returns {BoundingBoxNullable} The bounding box of an array of entities
 */
function computeBbox(entities) {
  let bbox = {};
  entities.forEach(e => {
    switch (e.type) {
      case 'ARC':
        extendBbox(bbox, (0, _getPointTangent.getPointTangentOfEntity)(e, 0)[0]);
        extendBbox(bbox, (0, _getPointTangent.getPointTangentOfEntity)(e, 1)[0]);
        let sa = e.startAngle;
        let ea = e.endAngle;
        while (sa < 0) {
          sa += Math.PI * 2;
          ea += Math.PI * 2;
        }
        while (sa >= Math.PI * 2) {
          sa -= Math.PI * 2;
          ea -= Math.PI * 2;
        }
        while (ea - sa <= 0) {
          ea += Math.PI * 2;
        }
        while (ea - sa > Math.PI * 2) {
          ea -= Math.PI * 2;
        }
        for (let a = 0; a <= ea; a += Math.PI / 2) {
          if (a >= sa) {
            extendBbox(bbox, {
              x: e.x + e.r * Math.cos(a),
              y: e.y + e.r * Math.sin(a)
            });
          }
        }
        break;
      case 'LINE':
        extendBbox(bbox, e.start);
        extendBbox(bbox, e.end);
        break;
      case 'CIRCLE':
        extendBbox(bbox, {
          x: e.x + e.r,
          y: e.y + e.r
        });
        extendBbox(bbox, {
          x: e.x - e.r,
          y: e.y - e.r
        });
        break;
      case 'LWPOLYLINE':
      case 'POLYLINE':
        const verts = e.vertices.slice();
        if (e.closed) {
          verts.push(verts[0]);
        }
        for (let i = 0; i < verts.length; i++) {
          let ip1 = (i + 1) % verts.length;
          extendBbox(bbox, verts[i]);
          let bulge = verts[i].bulge;
          if (bulge && (bulge < 0 || bulge > 0) && i < verts.length - 1) {
            try {
              let arc = (0, _convertLineToArc.convertLineToArc)(verts[i], verts[ip1], bulge);
              let arcbbox = computeBbox([arc]);
              extendBbox(bbox, arcbbox.min);
              extendBbox(bbox, arcbbox.max);
            } catch (ex) {
              console.log(ex);
            }
          }
        }
        break;
      default:
        throw new Error('Unsupported entity: ' + e.type);
    }
  });
  return bbox;
}
function extendBbox(bbox, p) {
  bbox.min = (0, _vector.min)(bbox.min, p);
  bbox.max = (0, _vector.max)(bbox.max, p);

  // if (!bbox.hasOwnProperty('min')) {
  //   bbox.min = { ...p }
  //   bbox.max = { ...p }
  // } else {
  //   bbox.min.x = Math.min(bbox.min.x, p.x)
  //   bbox.min.y = Math.min(bbox.min.y, p.y)
  //   bbox.max.x = Math.max(bbox.max.x, p.x)
  //   bbox.max.y = Math.max(bbox.max.y, p.y)
  // }
}